module.exports = __webpack_public_path__ + "static/media/elon_musk.ca36d40a.png";